import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MovimentosSidebar from './sidebar';
import Home from './home';  // Importe o Home.jsx

const MovimentosLayout = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const renderContent = () => {
        if (selectedOption === '') {
            // Se nenhuma opção for selecionada, renderize o Home (lista de movimentos)
            return <Home />;
        }
        switch (selectedOption) {
            case 'movEntrada':
                return <Typography variant="h6">Exibindo Movimentos de Entrada</Typography>;
            case 'movSaida':
                return <Typography variant="h6">Exibindo Movimentos de Saída</Typography>;
            case 'movPorData':
                return <Typography variant="h6">Exibindo Movimentos por Data</Typography>;
            case 'movPorCliente':
                return <Typography variant="h6">Exibindo Movimentos por Cliente</Typography>;
            case 'movPorFornecedor':
                return <Typography variant="h6">Exibindo Movimentos por Fornecedor</Typography>;
            case 'movPorFamilias':
                return <Typography variant="h6">Exibindo Movimentos por Famílias</Typography>;
            default:
                return (
                    <Typography variant="body1" align="center">
                        Selecione uma opção do menu para exibir os movimentos.
                    </Typography>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {sidebarVisible && (
                <Box
                    sx={{
                        width: '300px',
                        borderRight: '1px solid #ccc',
                        position: 'relative'
                    }}
                >
                    <MovimentosSidebar onOptionChange={handleOptionChange} />
                    <IconButton
                        onClick={() => setSidebarVisible(false)}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-20px',
                            backgroundColor: 'white',
                            boxShadow: 1
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            )}
            {!sidebarVisible && (
                <IconButton
                    onClick={() => setSidebarVisible(true)}
                    sx={{
                        position: 'absolute',
                        left: '0px',
                        top: '50%',
                        backgroundColor: 'white',
                        boxShadow: 1,
                        zIndex: 1
                    }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            <Box sx={{ flexGrow: 1, p: 2 }}>
                {renderContent()}
            </Box>
        </Box>
    );
};

export default MovimentosLayout;
